import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsSeoContent {
    export interface IComponentData extends NICmsContentComponent.IData {
        image?: string;
        title: string;
        text: string;
    }
}

@ICmsComponent<CmsSeoContentComponent>({
    id: 'seo-content',
    name: 'SEO Content Block',
    tags: ['PLP', 'Seo'],

    onDemandOnly: true,
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            key: 'title',
            required: true,
            default: 'SEO Title'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'text',
            title: 'Text',
            required: true,
            default:
                'Some SEO copy condimentum consectetur nunc iaculis non morbi eleifend. Non et sit quam sed eu a. Cras vestibulum eleifend vitae volutpat orci, cursus. Imperdiet eget vestibulum enim, egestas etiam pulvinar sit id molestie. In sit quisque imperdiet lectus magna vitae. Enim a nunc adipiscing augue id malesuada enim. Facilisi mi sed sit nunc.'
        },
        {
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image'
        }
    ]
})
@Component({
    selector: 'cms-seo-content',
    templateUrl: './cms-seo-content.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsSeoContentComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsSeoContent.IComponentData;
}
